import React, { Component } from "react";
import { NavLink } from "react-router-dom";
import axios from "../../../axios";
import Alert from "react-s-alert";
import qs from "qs";
import Paging from "../../../components/Paging";
import { CATEGORY_LIST } from "../endpoints";
import ModalHelp from "../../../components/ModalHelp";

import {BootstrapTable, TableHeaderColumn} from 'react-bootstrap-table';
import 'react-bootstrap-table/dist//react-bootstrap-table-all.min.css';

class Lists extends Component {
	constructor() {
		super();
		this.state = {
			dataKategori: [],
			exam_cat_id: 0,
			pageCount: 0,
			tutorial: '',
			currentPage: 0,
			isLoading: false,
			isModalHelpShow  : false,
			isModalShow: false,
			sortName : '',
			sortOrder : '',
			startNo : 1,
		};

		this.toggleModalHelp                = this.toggleModalHelp.bind(this)
	}

	toggleModalHelp() {

		this.setState({tutorial : 'https://www.youtube.com/embed/aPdLXeVnJBo'})

		this.setState({ isModalHelpShow: ! this.state.isModalHelpShow })
	}

	handlePageClick(data) {
		let selected = data.selected; // zero based index

		this.setState({ currentPage: selected }, () => {
			this.loadData();
		});
	}

	loadData() {
		this.setState({ isLoading: true });

		const params = qs.stringify({
			page: this.state.currentPage + 1,
			sortName : this.state.sortName,
			sortOrder : this.state.sortOrder,
		});

		axios({
			method: "post",
			url: CATEGORY_LIST + "?" + params
		})
			.then(response => {
				const result = response.data;
				if (result.success === true) {
					this.setState({
						dataKategori: result.data.data,
						pageCount: result.data.last_page,
						startNo : result.data.from,
						sortName : this.state.sortName,
						sortOrder : this.state.sortOrder,
						isLoading: false
					});
				} else {
					Alert.error(result.message);
					this.setState({ isLoading: false });
				}
			})
			.catch(error => {
				console.log(error);
				this.setState({ isLoading: false });
				Alert.error("Gagal terhubung ke server!");
			});
	}

	componentDidMount() {
		if(localStorage.SISMART_USER_LEVEL !=='administrator'){
			this.props.history.replace("/dashboard");
        }
		this.loadData();
	}

	componentDidUpdate(prevProps, prevState) {

		if (prevState.sortName !== this.state.sortName
			|| prevState.sortOrder !== this.state.sortOrder
		) {
			this.loadData()
		}
	}

	onSortChange(sortName, sortOrder) {
		this.setState({
			sortName,
			sortOrder
		});
	}

	render() {
		const strt = this.state.startNo;
		const url = this.props.match.url;

		function indexN(cell, row, enumObject, index){
			return (<div>{index+strt}</div>)
		}

		function formatStatus(cell, row, enumObject, index){
			if(row.exam_cat_status === '1'){
				return (<span className="badge badge-primary">Active</span>);
			}else{
				return (<span className="badge badge-danger">Non-Active</span>);
			}
		}

		function formatOpsi(cell, row, enumObject, index){
			return (
				<NavLink
					to={`${url}/edit/${
						row.exam_cat_id
					}`}
					className="btn btn-secondary btn-sm"
				>
					Edit
				</NavLink>
			)
		}

		const options = {
			clearSearch: true,
			searchPosition: 'left',
			sortName : this.state.sortName,
			sortOrder : this.state.sortOrder,
			onSortChange : this.onSortChange.bind(this)
		}

		return (
			<div>

				<ModalHelp
					isShow={this.state.isModalHelpShow}
					toggleModal={this.toggleModalHelp}
					handleSubmit={this.handleSubmitDeleteButton}
					modalHeaderText="Tutorial Penggunaan Fitur"
					modalBodyText={this.state.tutorial}
					modalSubmitText="Ya" />

				<div className="card">
					<div className="card-block">
						<NavLink
							to={`${this.props.match.url}/add`}
							className="btn btn-primary"
						>
							Tambah Kategori Ujian
						</NavLink>
					</div>
				</div>
				<div className="card">
					<div className="card-header">Data Kategori Ujian

						<button
							type="button"
							title='Tutorial'
							className="btn btn-danger btn-sm"
							style={{ float: 'right'}}
							onClick={() => {
								this.toggleModalHelp();
								// this.setState({ tutorial: levelName});
							}}
						>
							<i className="fa fa-question-circle"s></i>
						</button>
					</div>
					<div className="card-block">
						{this.state.isLoading ? (
							"Memuat Data..."
						) : this.state.dataKategori.length === 0 ? (
							"Data Kosong..."
						) : (
							<div>
								<div>
									<BootstrapTable data={this.state.dataKategori} striped hover remote options={options}>
										<TableHeaderColumn width='50' dataField="any" dataFormat={indexN} isKey>No</TableHeaderColumn>
										<TableHeaderColumn width='250' dataField="exam_cat_name" dataSort>Nama Kategori</TableHeaderColumn>
										<TableHeaderColumn width='250' dataField="exam_cat_type" dataSort>Ujian/Tugas</TableHeaderColumn>
										<TableHeaderColumn width='100' dataField="exam_cat_status" dataFormat={formatStatus} dataSort>Status</TableHeaderColumn>
										<TableHeaderColumn width='100' dataField="any" dataFormat={formatOpsi}>Opsi</TableHeaderColumn>
									</BootstrapTable>
								</div>

								<Paging
									handlePageClick={this.handlePageClick.bind(this)}
									pageCount={this.state.pageCount}
									currentPage={this.state.currentPage}
								/>
							</div>
						)}
					</div>
				</div>
			</div>
		);
	}
}

export default Lists;



// WEBPACK FOOTER //
// ./src/views/Exam/Category/Lists.js